import { N20A, N500, N600, N800 } from '@atlaskit/theme/colors';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

export const CharlieDisplayFontStack =
  "'Charlie Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;";

export const CharlieTextFontStack =
  "'Charlie Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif;";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0px;
  align-items: center;
  font-family: ${CharlieTextFontStack};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #091e42;
  letter-spacing: 0.05em;

  a {
    text-decoration: none !important;
  }

  a:hover {
    text-decoration: underline !important;
  }

  svg {
    margin-bottom: 0 !important;
  }
`;

export const Header = styled.span`
  padding: 25px 0;
  font-weight: 600;
  font-family: ${CharlieDisplayFontStack};
  font-size: 1.25em;
  line-height: 1.2;
  letter-spacing: unset;
  color: #172b4d;
`;
export const DevopsHeader = styled.span`
  font-size: 32px;
  line-height: 40px;
  font-family: ${CharlieDisplayFontStack};
  color: ${N600};
  font-weight: 400;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;

  @media only screen and (max-width: 769px) {
    font-size: 24px;
    line-height: 28px;
    padding-bottom: 16px;
  }

  span:first-child {
    padding-bottom: 14px;
  }

  @media only screen and (max-width: 424px) {
    max-width: 266px;
  }
`;
export const DevopsImageWrapper = styled.div`
  width: 225px;
  padding-bottom: 25px;
  display: flex;
  justify-content: center;
  margin-top: 35px;

  @media only screen and (max-width: 769px) {
    margin-top: 16px;
    padding-bottom: 20px;
  }
`;
export const ImageWrapper = styled.div`
  width: 225px;
  padding-bottom: 25px;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 25px;
  align-items: center;
`;

export const Bold = styled.span`
  font-weight: 900;
`;

export const RotationKeyframes = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Devopsgroup = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 0px;
  align-items: center;
  text-align: center;
  max-width: 422px;

  @media only screen and (max-width: 769px) {
    max-width: 300px;
  }
`;
export const DevopsText = styled.p`
  font-family: ${CharlieTextFontStack};
  color: ${N800};
  div {
    font-weight: 600;
    display: contents;

    @media only screen and (max-width: 769px) {
      display: block;
    }
  }

  &.break div {
    @media only screen and (max-width: 769px) {
      padding-bottom: 10px;
    }
  }
`;
export const DevopsButtonGroup = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  button {
    background: ${N20A};
    border-radius: 3px;
    padding: 6px 12px;
  }
  span {
    color: ${N500};
    font-size: 14px;
    line-height: 20px;
    font-family: ${CharlieTextFontStack};
  }
`;
